module.exports = __webpack_public_path__ + "img/default.1438bbc1.png";